import axios from 'axios'

// CONFIG
export const domain = process.env.REACT_APP_DOMAIN || ''
export const apiDomain = `${domain}/api`
export const apiKey = process.env.REACT_APP_API_KEY

export class request {
  static headers = {
    'X-Api-Key': apiKey
  }

  static fetch = options => {
    return axios({
      name: '',
      parts: '',
      withCredentials: true,
      ...options
    }).catch(error => {
      if (error && error.response && error.response.status === 403) {
        const refreshed = sessionStorage.getItem('refreshed') === 'true'

        if (!refreshed) {
          sessionStorage.setItem('refreshed', 'true')
          window.location = window.location.pathname
        }
      }
      return Promise.reject(error)
    })
  }

  static upload = (path, data) => {
    return request.fetch({
      method: 'post',
      url: apiDomain + path,
      data,
      headers: {
        ...request.headers,
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  static get = (path, cancelToken) => {
    return request.fetch({
      method: 'get',
      url: apiDomain + path,
      headers: request.headers,
      cancelToken
    })
  }

  static delete = path => {
    return request.fetch({
      method: 'delete',
      url: apiDomain + path,
      headers: request.headers
    })
  }

  static post = (path, data) => {
    return request.fetch({
      method: 'post',
      url: apiDomain + path,
      headers: request.headers,
      data
    })
  }

  static patch = (path, data) => {
    return request.fetch({
      method: 'patch',
      url: apiDomain + path,
      headers: request.headers,
      data
    })
  }

  static put = (path, data) => {
    return request.fetch({
      method: 'put',
      url: apiDomain + path,
      headers: request.headers,
      data
    })
  }
}
